var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridClient",attrs:{"name":"filterGridClient","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c52e35b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Filters/ClientFilter.vue
// module id = 925
// module chunks = 1